import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";
import {
    GetSonyBulkUploadDataRequest,
    getLetterOnboardingEmployeeListRequest,
    setSonyBulkUploadTab,
} from "../../../Redux/Slice";
import SonyBulkuploadPopup from "./SonyBulkuploadPopup";
import LetterOnboardingPopup from "./LetterOnboardingPopup";
import { useNavigate } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import fileDownloadIcon from "../../../Assets/fileDownload.png";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import swal from "sweetalert2";
import axios from "axios";
import { toast } from "react-toastify";
import { getLoaderAction } from "../../../Redux/Loader";
import { sonyBulkUploadListApi } from "../../../text/apidata";

// Display-only formatting; salary values always come from the API.
const formatRupee = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const num = Number(value);
    if (Number.isNaN(num)) return "-";
    return `₹${num.toLocaleString("en-IN")}`;
};

const SonyBulkupload = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive,
    );
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // Tab state from Redux store
    const selectedTab = useSelector(
        (state) => state?.sonyBulkUploadTab?.selectedTab
    );
    console.log(selectedTab, "dasjkdkjasjkaks")

    // Onboarding Pagination & Search states
    const [sno, setsno] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [search, setsearch] = useState("");
    const [pageSize, setPageSize] = useState(20);

    // Letter Onboarding Pagination & Search states
    const [letterSno, setLetterSno] = useState(0);
    const [letterCurrentPage, setLetterCurrentPage] = useState(1);
    const [letterPageindex, setLetterPageindex] = useState(1);
    const [letterPagesize, setLetterPagesize] = useState(10);
    const [letterSearch, setLetterSearch] = useState("");

    // Redux Data
    const { sonyBulkUploaddata, totalCount: sonyTotalCount } = useSelector(
        (state) => state?.sonyBulkUploadGetData || {},
    );

    const { letterOnboardingEmployeeListData, totalCount: letterTotalCount } = useSelector(
        (state) => state?.letterOnboardingEmployeeList || {},
    );

    const [bulkUploadPopup, setBulkUploadPopup] = useState(false);
    const [statusVal, setStatusVal] = useState({ value: "", label: "All" });
    const [letterStatusVal, setLetterStatusVal] = useState({ value: "", label: "All" });

    const statusOptions = useMemo(
        () => [
            { value: "", label: "All" },
            { value: "0", label: "Link Sent" },
            { value: "1", label: "Link Expired" },
            { value: "2", label: "Completed" },
        ],
        [],
    );

    const letterStatusOptions = useMemo(
        () => [
            { value: "", label: "All" },
            { value: "0", label: "Appointment Letter" },
            { value: "1", label: "Salary Revision" },
            { value: "2", label: "MW Revision" },
            { value: "3", label: "Salary Structure Revision" },
            { value: "4", label: "Contract Renewal" },
            { value: "5", label: "Poor Performance" },
            { value: "6", label: "PIP" },
            { value: "7", label: "Indiscipline" },
            { value: "8", label: "Absconding" },
            { value: "9", label: "False Attendance" },
            { value: "10", label: "False Bill Submission" },
            { value: "11", label: "Transfer Letter" },
            { value: "12", label: "Relieving Letter" },
            { value: "13", label: "Experience Letter" },
            { value: "14", label: "Relinquishment Letter" },
            { value: "15", label: "Designation Change Letter" },
            { value: "16", label: "Role Change Letter" },
        ],
        [],
    );

    const count = (c, label, value, selectedVal) => {
        setdtPageindex(1);
        setsno(0);
        setStatusVal(selectedVal || { value: "", label: "All" });
    };

    const ClearState = () => {
        setdtPageindex(1);
        setsno(0);
        setStatusVal({ value: "", label: "All" });
    };

    const letterCount = (c, label, value, selectedVal) => {
        setLetterPageindex(1);
        setLetterSno(0);
        setLetterStatusVal(selectedVal || { value: "", label: "All" });
    };

    const letterClearState = () => {
        setLetterPageindex(1);
        setLetterSno(0);
        setLetterStatusVal({ value: "", label: "All" });
    };

    const pagesize = (arg) => {
        setdtPagesize(arg);
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };

    const letterPagesizeHandler = (arg) => {
        setLetterPagesize(arg);
    };

    const letterPageindexHandler = (arg) => {
        setLetterPageindex(arg);
    };

    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        [],
    );

    const debouncedLetterSearch = useMemo(
        () =>
            _.debounce((e) => {
                setLetterSearch(e);
            }, 500),
        [],
    );

    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);
    }

    function letterSearchChange(e) {
        setLetterPageindex(1);
        debouncedLetterSearch(e);
    }

    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const handleLetterNext = (next) => {
        setLetterPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage);
    };

    const GotoEnteredLetterPage = (gotopage) => {
        setLetterPageindex(gotopage);
    };

    const handleDownload = (url) => {
        if (!url) return;
        window.open(url, "_blank");
    };

    const handleTabChange = (tabName) => {
        dispatch(setSonyBulkUploadTab(tabName));
        setdtPageindex(1);
        setCurrentPage(1);
        setsno(0);
        setsearch("");
        setStatusVal({ value: "", label: "All" });

        setLetterPageindex(1);
        setLetterCurrentPage(1);
        setLetterSno(0);
        setLetterSearch("");
        setLetterStatusVal({ value: "", label: "All" });
    };

    // Fetch Onboarding Tab Data
    useEffect(() => {
        if (selectedTab === "Onboarding") {
            const payload = {
                page_size: 20,
                page: dtpageindex,
                search: search,
                status: statusVal?.value ?? "",
            };
            dispatch(GetSonyBulkUploadDataRequest(payload));
        }
    }, [selectedTab, dispatch, dtpageindex, search, statusVal]);

    const userSessionData = useSelector((state) => state.users.UserData);

    // Delete Onboarding record API Handler
    const handleDeleteOnboarding = async (id) => {
        try {
            dispatch(getLoaderAction(true));
            const response = await axios({
                method: "delete",
                url: `${sonyBulkUploadListApi}${id}/`,
                headers: {
                    Authorization: "Bearer " + userSessionData?.session?.token,
                },
            });
            dispatch(getLoaderAction(false));
            toast.success(response?.data?.message || "Record deleted successfully");
            // last record on a later page: go back a page (the effect refetches), else refetch this page
            if ((sonyBulkUploaddata?.length || 0) <= 1 && dtpageindex > 1) {
                setdtPageindex(dtpageindex - 1);
            } else {
                dispatch(
                    GetSonyBulkUploadDataRequest({
                        page_size: 20,
                        page: dtpageindex,
                        search: search,
                        status: statusVal?.value ?? "",
                    }),
                );
            }
        } catch (error) {
            dispatch(getLoaderAction(false));
            toast.error(
                error?.response?.data?.message ||
                error?.response?.data?.status?.message ||
                "Failed to delete record"
            );
        }
    };

    // Delete Confirmation with Swal
    const handleDeleteOnboardingConfirm = (item) => {
        swal.fire({
            title: "Are you sure?",
            text: `Do you want to delete ${item?.employee_name || item?.name || "this record"}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ef4d39",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                handleDeleteOnboarding(item.id);
            }
        });
    };

    // Fetch Letter Onboarding Employee List Data
    useEffect(() => {
        if (selectedTab === "Letter Onboarding") {
            const payload = {
                page_size: 20,
                page: letterPageindex,
                search: letterSearch,
                status: letterStatusVal?.value ?? "",
                report_type: letterStatusVal?.value ?? "",
            };
            dispatch(getLetterOnboardingEmployeeListRequest(payload));
        }
    }, [selectedTab, dispatch, letterPageindex, letterSearch, letterStatusVal]);

    const handlePrevious = (previous) => {
        if (previous !== 0) {
            setdtPageindex(previous);
        }
    };

    const handleLetterPrevious = (previous) => {
        if (previous !== 0) {
            setLetterPageindex(previous);
        }
    };

    // Onboarding Columns
    const columns = useMemo(
        () => [
            {
                Header: "S.NO",
                accessor: "",
                Cell: (row) => {
                    return <p>{Number(sno + row.row.index + 1)}</p>;
                },
            },
            {
                Header: "Employee Name",
                accessor: "employee_name",
                Cell: (row) => {
                    return (
                        <span className="wrap-cell" style={{ minWidth: "150px", maxWidth: "200px" }}>
                            {row.row.original?.employee_name || row.row.original?.name || "-"}
                        </span>
                    );
                },
            },
            {
                Header: "Phone Number",
                accessor: "phone_number",
                Cell: (row) => {
                    return <span>{row.row.original?.phone_number || row.row.original?.mobile_number || "-"}</span>;
                },
            },
            {
                Header: "Email",
                accessor: "email",
                Cell: (row) => {
                    return <span>{row.row.original?.email || "-"}</span>;
                },
            },
            {
                Header: "Designation",
                accessor: "role",
                Cell: (row) => {
                    return (
                        <span className="wrap-cell" style={{ minWidth: "140px", maxWidth: "200px" }}>
                            {row.row.original?.designation_id?.role || row.row.original?.role || "-"}
                        </span>
                    );
                },
            },
            {
                Header: "Basic",
                accessor: "basic",
                Cell: (row) => <span>{formatRupee(row.row.original?.basic)}</span>,
            },
            {
                Header: "HRA",
                accessor: "hra",
                Cell: (row) => <span>{formatRupee(row.row.original?.hra)}</span>,
            },
            {
                Header: "Conveyance Allowance",
                accessor: "conveyance_allowance",
                Cell: (row) => (
                    <span>{formatRupee(row.row.original?.conveyance_allowance)}</span>
                ),
            },
            {
                Header: "Professional Tax",
                accessor: "professional_tax",
                Cell: (row) => (
                    <span>{formatRupee(row.row.original?.professional_tax)}</span>
                ),
            },
            {
                Header: "Gross Salary",
                accessor: "gross_salary",
                Cell: (row) => (
                    <span>
                        {formatRupee(row.row.original?.gross_salary ?? row.row.original?.salary)}
                    </span>
                ),
            },
            {
                Header: "Net Salary",
                accessor: "net_salary",
                Cell: (row) => <span>{formatRupee(row.row.original?.net_salary)}</span>,
            },
            {
                Header: "DOJ",
                accessor: "doj",
                Cell: (row) => {
                    return (
                        <span style={{ textWrap: "nowrap" }}>
                            {row.row.original?.doj ? String(row.row.original.doj).slice(0, 10) : "-"}
                        </span>
                    );
                },
            },
            {
                Header: "Employee Sign",
                accessor: "employee_sign_url",
                Cell: (row) => {
                    return <span>{row.row.original?.employee_sign_url ? "Signed" : "Not Signed"}</span>;
                },
            },
            {
                Header: "Link Status",
                accessor: "status",
                Cell: (row) => {
                    const inviteSent = row.row.original?.is_invite_link_sent;
                    const linkExpired = row.row.original?.link_expired;
                    const signedAt = row.row.original?.signed_at;
                    return (
                        <span>
                            {inviteSent === true && linkExpired === false && signedAt == null
                                ? "Link Sent"
                                : linkExpired === true
                                    ? "Link Expired"
                                    : inviteSent && signedAt ? "Completed"
                                        : "-"}
                        </span>
                    );
                },
            },
            {
                Header: "Signed At",
                accessor: "",
                Cell: (row) => {
                    const dateString = row.row.original.signed_at;
                    if (!dateString) return "-";
                    const dateObject = new Date(dateString);
                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12;
                    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
                    return (
                        <span style={{ textWrap: "nowrap" }}>
                            {`${row.row.original.created_at?.slice(0, 10) || ""} ${formattedTime}`}
                        </span>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "is_active",
                Cell: (row) => {
                    return <span>{row.row.original?.is_active ? "Active" : "In Active"}</span>;
                },
            },
            {
                Header: "Created Date",
                accessor: "",
                Cell: (row) => {
                    const dateString = row.row.original.created_at;
                    if (!dateString) return "-";
                    const dateObject = new Date(dateString);
                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12;
                    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
                    return (
                        <span style={{ textWrap: "nowrap" }}>
                            {`${row.row.original.created_at.slice(0, 10)} ${formattedTime}`}
                        </span>
                    );
                },
            },
            {
                Header: "Offer Letter",
                accessor: "offer_letter",
                Cell: (row) => {
                    const url = row.row.original?.offer_letter || row.row.original?.pdf_file || row.row.original?.file;

                    return url ? (
                        <span
                            onClick={() => handleDownload(url)}
                            title="Download Uploaded Sheet"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                cursor: "pointer",
                                border: "1px solid green",
                                backgroundColor: "green",
                                padding: "3px 7px",
                                color: "white",
                                borderRadius: "5px",
                            }}
                        >
                            <img
                                src={fileDownloadIcon}
                                alt="Download"
                                style={{ width: "30px", height: "30px" }}
                            />{" "}
                            <span>Download</span>
                        </span>
                    ) : null;
                },
            },
            {
                Header: "Actions",
                accessor: "",
                Cell: (row) => {
                    const item = row.row.original;
                    return (
                        <div className="actions" style={{ display: "flex", justifyContent: "flex-start", gap: "5px" }}>
                            <button
                                type="button"
                                className="btn Status"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteOnboardingConfirm(item);
                                }}
                            >
                                <span className="OuterActionSpan">
                                    <span className="EditImages">
                                        <img src={DeleteImages} alt="delete" />
                                    </span>
                                    <span className="ActionsList"> Delete </span>
                                </span>
                            </button>
                        </div>
                    );
                },
            },
        ],
        [sonyBulkUploaddata, sno, dtpageindex, search, statusVal],
    );

    // Letter Onboarding Employee List Columns
    const letterOnboardingEmployeeColumns = useMemo(
        () => [
            {
                Header: "S.NO",
                accessor: "",
                Cell: (row) => {
                    return <p>{Number(letterSno + row.row.index + 1)}</p>;
                },
            },
            {
                Header: "Employee Name",
                accessor: "employee_name",
                Cell: (row) => {
                    return (
                        <span
                            style={{
                                width: "160px",
                                display: "inline-block",
                                wordBreak: "break-word",
                                overflowWrap: "break-word",
                                textWrap: "wrap",
                            }}
                        >
                            {row.row.original?.employee_name || row.row.original?.name || "-"}
                        </span>
                    );
                },
            },
            {
                Header: "Phone Number",
                accessor: "phone_number",
                Cell: (row) => {
                    return <span>{row.row.original?.phone_number || row.row.original?.mobile_number || "-"}</span>;
                },
            },
            {
                Header: "Email",
                accessor: "email",
                Cell: (row) => {
                    return <span>{row.row.original?.email || "-"}</span>;
                },
            },
            // {
            //     Header: "Designation",
            //     accessor: "role",
            //     Cell: (row) => {
            //         return <span>{row.row.original?.designation_id?.role || row.row.original?.designation || row.row.original?.role || "-"}</span>;
            //     },
            // },
            // {
            //     Header: "Gross Salary",
            //     accessor: "gross_salary",
            //     Cell: (row) => {
            //         return <span>{row.row.original?.gross_salary || row.row.original?.salary || "-"}</span>;
            //     },
            // },
            {
                Header: "Letter Type",
                accessor: "report_type",
                Cell: (row) => {
                    const rType = row.row.original?.report_type ?? row.row.original?.pdf_type ?? row.row.original?.type;
                    const matched = letterStatusOptions.find((opt) => String(opt.value) === String(rType));
                    return <span>{matched ? matched.label : (rType ?? "-")}</span>;
                },
            },
            {
                Header: "Created Date",
                accessor: "",
                Cell: (row) => {
                    const dateString = row.row.original?.created_at;
                    if (!dateString) return "-";
                    const dateObject = new Date(dateString);
                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12;
                    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
                    return (
                        <span style={{ textWrap: "nowrap" }}>
                            {`${dateString.slice(0, 10)} ${formattedTime}`}
                        </span>
                    );
                },
            },
            {
                Header: "PDF",
                accessor: "pdf_url",
                Cell: (row) => {
                    const url = row.row.original?.pdf_url;
                    return url ? (
                        <span
                            onClick={() => handleDownload(url)}
                            title="Download Letter"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                cursor: "pointer",
                                border: "1px solid green",
                                backgroundColor: "green",
                                padding: "3px 7px",
                                color: "white",
                                borderRadius: "5px",
                                width: "133px"
                            }}
                        >
                            <img
                                src={fileDownloadIcon}
                                alt="Download"
                                style={{ width: "30px", height: "30px" }}
                            />{" "}
                            <span>Download</span>
                        </span>
                    ) : (
                        "-"
                    );
                },
            },
        ],
        [letterOnboardingEmployeeListData, letterSno, letterStatusOptions],
    );

    return (
        <div className={stateDisplay ? "outterContent" : "inner-Content"}>
            <div
                className="Header-Details ClientBranch"
                style={{
                    padding: "14px 28px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px !important",
                }}
            >
                <div
                    className="col-sm-7 auto"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "25px",
                    }}
                >
                    <span
                        className="user-name mb-0"
                        style={{
                            cursor: "pointer",
                            fontSize: "18px",
                            fontWeight: selectedTab === "Onboarding" ? "600" : "400",
                            color: selectedTab === "Onboarding" ? "#f26639" : "#6b7280",
                            borderBottom:
                                selectedTab === "Onboarding"
                                    ? "3px solid #f26639"
                                    : "3px solid transparent",
                            paddingBottom: "8px",
                            transition: "all 0.3s ease",
                        }}
                        onClick={() => handleTabChange("Onboarding")}
                    >
                        Onboarding
                    </span>

                    <span
                        className="user-name mb-0"
                        style={{
                            cursor: "pointer",
                            fontSize: "18px",
                            fontWeight: selectedTab === "Letter Onboarding" ? "600" : "400",
                            color: selectedTab === "Letter Onboarding" ? "#f26639" : "#6b7280",
                            borderBottom:
                                selectedTab === "Letter Onboarding"
                                    ? "3px solid #f26639"
                                    : "3px solid transparent",
                            paddingBottom: "8px",
                            transition: "all 0.3s ease",
                        }}
                        onClick={() => handleTabChange("Letter Onboarding")}
                    >
                        Letter Onboarding
                    </span>
                </div>
                <div
                    className="Add-User col-sm-5"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        justifyContent: "flex-end",
                    }}
                >
                    {selectedTab === "Onboarding" ? (
                        <button
                            onClick={() => {
                                navigate("/sonybulkupload/status");
                            }}
                            className="ButtonCSS"
                            style={{ marginBottom: "10px" }}
                        >
                            Bulkupload Status
                        </button>
                    ) : (
                        <button
                            onClick={() => {
                                navigate("/sonybulkupload/letteronboardhistory");
                            }}
                            className="ButtonCSS"
                            style={{ marginBottom: "10px" }}
                        >
                            Bulkupload Status
                        </button>
                    )}
                    <button
                        onClick={() => {
                            setBulkUploadPopup(true);
                        }}
                        className="ButtonCSS"
                        style={{ marginBottom: "10px" }}
                    >
                        Bulk Upload
                    </button>
                </div>
            </div>
            <div
                style={{
                    padding: "0px 40px",
                    marginTop: "-13px",
                    marginBottom: "20px",
                }}
            >
                {selectedTab === "Onboarding" ? (
                    <div className="sony-onboarding-table">
                    {/* wide table: keep cells on one line and scroll horizontally (table-responsive wrapper) */}
                    <style>{`
                        .sony-onboarding-table .table-responsive { overflow-x: auto; container-type: inline-size; }
                        .sony-onboarding-table .INNERTABLE { width: max-content; min-width: 100%; }
                        .sony-onboarding-table .Dusbinbacktabls { position: sticky; left: 0; width: 100cqw; }
                        .sony-onboarding-table .table-responsive > .row { position: sticky; left: 0; width: 100cqw !important; }
                        .sony-onboarding-table .TableDesgin { min-width: 2200px; }
                        .sony-onboarding-table .TableDesgin th {
                            width: auto !important;
                            white-space: nowrap;
                            vertical-align: middle;
                            padding: 12px 14px !important;
                        }
                        .sony-onboarding-table .TableDesgin td {
                            white-space: nowrap;
                            vertical-align: middle;
                            padding: 12px 14px !important;
                        }
                        .sony-onboarding-table .TableDesgin td p { margin: 0; }
                        .sony-onboarding-table .wrap-cell {
                            display: inline-block;
                            white-space: normal;
                            word-break: break-word;
                        }
                    `}</style>
                    <ReactTable
                        data={sonyBulkUploaddata ? sonyBulkUploaddata : []}
                        columns={columns}
                        filterRowAction={
                            <button
                                onClick={() => {
                                    navigate("/reportsheet", {
                                        state: {
                                            openCreate: true,
                                            reportType: "sony_bulk_offer_report",
                                        },
                                    });
                                }}
                                className="ButtonCSS"
                                style={{
                                    background: "#F15D39",
                                    color: "#fff",
                                    opacity: 1,
                                    padding: "10px 28px",
                                    borderRadius: "6px",
                                    border: "none",
                                    fontWeight: 600,
                                }}
                            >
                                Download
                            </button>
                        }
                        currentPage={currentPage}
                        onChange={tochange}
                        setCurrentPage={setCurrentPage}
                        pagesize={pagesize}
                        dtpagesize={pageSize}
                        dtpageindex={dtpageindex}
                        pageindex={pageindex}
                        totalItems={sonyTotalCount}
                        datacount={sonyTotalCount}
                        MakeCreate={false}
                        Filter={true}
                        ApproveRequestFilter={true}
                        options={statusOptions}
                        values={statusVal}
                        count={count}
                        ClearState={ClearState}
                        search_key={true}
                        searchVal={search}
                        onPrevious={handlePrevious}
                        onNextpage={handleNext}
                        GotoEnteredPage={GotoEnteredPage}
                        placeHold={"All"}
                        setsno={setsno}
                        sno={sno}
                        id={"spe"}
                    />
                    </div>
                ) : (
                    <ReactTable
                        data={letterOnboardingEmployeeListData ? letterOnboardingEmployeeListData : []}
                        columns={letterOnboardingEmployeeColumns}
                        currentPage={letterCurrentPage}
                        onChange={letterSearchChange}
                        setCurrentPage={setLetterCurrentPage}
                        pagesize={letterPagesizeHandler}
                        dtpagesize={pageSize}
                        dtpageindex={letterPageindex}
                        pageindex={letterPageindexHandler}
                        totalItems={letterTotalCount}
                        datacount={letterTotalCount}
                        MakeCreate={false}
                        Filter={true}
                        ApproveRequestFilter={true}
                        options={letterStatusOptions}
                        values={letterStatusVal}
                        count={letterCount}
                        ClearState={letterClearState}
                        search_key={true}
                        searchVal={letterSearch}
                        onPrevious={handleLetterPrevious}
                        onNextpage={handleLetterNext}
                        GotoEnteredPage={GotoEnteredLetterPage}
                        placeHold={"All"}
                        setsno={setLetterSno}
                        sno={letterSno}
                        id={"spe"}
                    />
                )}
            </div>
            {bulkUploadPopup && (
                selectedTab === "Onboarding" ? (
                    <SonyBulkuploadPopup setPopup={setBulkUploadPopup} />
                ) : (
                    <LetterOnboardingPopup setPopup={setBulkUploadPopup} />
                )
            )}
        </div>
    );
};

export default SonyBulkupload;